/**
 * Labstep
 *
 * @module components/Group/Settings/Inventory
 * @desc   Group settings for Inventory
 */

import { LayoutLinks } from 'labstep-web/components/Layout/Links';
import { PremiumFeatureScreenGuard } from 'labstep-web/core/PremiumFeature/ScreenGuard';
import { TagType } from 'labstep-web/models/tag.model';
import { ScreensResourceLocationIndex } from 'labstep-web/screens/ResourceLocation/Index';
import { ResourceTemplateIndex } from 'labstep-web/screens/ResourceTemplate/Index';
import { TagIndex } from 'labstep-web/screens/Tag/Index';
import type React from 'react';
import type { GroupSettingsInventoryProps } from './types';

export const GroupSettingsInventory: React.FC<
  GroupSettingsInventoryProps
> = ({ group }) => {
  return (
    <div id="group-settings-inventory" style={{ flex: 1 }}>
      <PremiumFeatureScreenGuard unstyled premiumFeature="inventory">
        <LayoutLinks
          inverted
          links={[
            {
              children: 'Categories',
              route: {
                to: 'group_settings_inventory_categories',
                params: { id: group.id },
              },
              render: () => <ResourceTemplateIndex group={group} />,
            },
            {
              children: 'Locations',
              route: {
                to: 'group_settings_inventory_locations',
                params: { id: group.id },
              },
              render: () => (
                <ScreensResourceLocationIndex group={group} />
              ),
            },
            {
              children: 'Tags',
              route: {
                to: 'group_settings_inventory_tags',
                params: { id: group.id },
              },
              render: () => (
                <TagIndex group={group} type={TagType.resource} />
              ),
            },
          ]}
        />
      </PremiumFeatureScreenGuard>
    </div>
  );
};
